// --- 订单管理 --- //

export default [
  {
    name: 'roomManagement',
    path: '/receptionSupervise/roomManagement',
    meta: { title: '订单管理' },
    component: require('business/receptionSupervise/roomManagement/list.vue').default
  },
  {
    name: 'roomManagementDetail',
    path: '/receptionSupervise/roomManagementDetail',
    meta: { title: '宾馆管理' },
    component: require('business/receptionSupervise/roomManagement/detail.vue').default
  }
];
